"use strict";

export { PanResponderAdapter as Pager } from "./PanResponderAdapter.js";
//# sourceMappingURL=Pager.js.map